import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RetailerComponent } from './retailer.component';
import { NewRetailerSmartComponent } from './new-retailer/new-retailer-smart.component';
import { AllRetailersComponent } from './all-retailers/all-retailers.component';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';
import { ManageRetailerComponent } from './manage-retailer/manage-retailer.component';
import { EditRetailerSmartComponent } from './manage-retailer/edit-retailer/edit-retailer-smart.component'
import { ViewPaymentHistoryComponent } from './manage-retailer/view-payment-history/view-payment-history.component';
import { CloseRetailersComponent } from './close-retailers/close-retailers.component';
import { DeleteRetailerComponent } from './close-retailers/delete-retailer/delete-retailer.component';

import { CommentsComponent } from './manage-retailer/comments/comments.component';
import { CreatecommentsComponent } from './manage-retailer/comments/createcomments/createcomments.component';
import { EditcommentComponent } from './manage-retailer/comments/editcomment/editcomment.component';
import { RetailerTiersComponent } from './retailer-tiers/retailer-tiers.component';
import { ManageTiersComponent } from './retailer-tiers/manage-tiers/manage-tiers.component';
import { AllTiersComponent } from './retailer-tiers/all-tiers/all-tiers.component';
import { RetailerRequestsComponent } from './retailer-requests/retailer-requests.component';
import { TransactionsHistoryComponent } from './manage-retailer/transactions/transactions-history.component';

export const retailerRoutes: Routes = [
  {
    path: 'allretailers', component: AllRetailersComponent,
  },
  {
    path: 'manageretailer/:retailerId', component: ManageRetailerComponent,
    children: [
      {
        path: 'updateretailer/:retailerId', component: EditRetailerSmartComponent,
      },
      {
        path: 'transactions/:retailerId', component: TransactionsHistoryComponent,
      },
      {
        path: 'payment-history/:retailerId', component: ViewPaymentHistoryComponent,
      },
      {
        path: 'comments/:retailerId', component: CommentsComponent,
      },
      {
        path: 'comments/:retailerId/edit/:commentId', component: EditcommentComponent,
      },
      {
        path: 'comments/:retailerId/create', component: CreatecommentsComponent,
      },
      {
        path: 'comments/:retailerId/create/:commentId', component: CreatecommentsComponent,
      },
    ]
  },
  {
    path: 'addretailer', component: NewRetailerSmartComponent,
  },
  {
    path: 'close-retailers', component: CloseRetailersComponent,
  },
  {
    path: 'retailer-requests', component: RetailerRequestsComponent,
  },
  
  {
    path: 'retailer-tiers', component: RetailerTiersComponent,
    children: [
      { path: 'all-tiers', component: AllTiersComponent },
      { path: 'manage-tiers', component: ManageTiersComponent },
      { path: 'manage-tiers/:retailerTierId', component: ManageTiersComponent },
      {
        path: '', redirectTo: 'all-tiers', pathMatch: 'full'
      },
    ]
  },
  {
    path: 'deleteretailer/:id', component: DeleteRetailerComponent,
  },
  {
    path: '', redirectTo: 'allretailers', pathMatch: 'full'
  },
  {
    path: '**', component: PageNotFoundComponent
  }
]
@NgModule({
  imports: [RouterModule.forChild(retailerRoutes)],
  exports: [RouterModule]
})
export class RetailerRoutingModule { }
